<template>
  <section>
    <div class="row">
      <div class="grid">
        <div
          v-if="$slots.sidebar"
          class="col columns"
          style="max-width: 340px; width: 30%; flex: none"
        >
          <slot name="sidebar"></slot>
        </div>
        <div v-if="$slots.main" class="col pl-6 pl-unset">
          <slot name="main"></slot>
        </div>
      </div>
    </div>
  </section>
</template>
